import { FloatingFormItem } from '@/components/_common';
import { UpdateIpiValueInInvoiceItemEnum } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { Checkbox, Form, Modal, Select, Typography } from 'antd';
import { useState } from 'react';

interface Props {
  open: boolean;
  hasKey?: boolean;
  isLoading: boolean;
  onCancel: () => void;
  setIsGenerateDocument: React.Dispatch<React.SetStateAction<boolean>>;
  onOk: (updateIpiValueInInvoiceItem?: UpdateIpiValueInInvoiceItemEnum) => void;
}

export default function UpdateIpiValueInvoiceItemModal({
  setIsGenerateDocument,
  open,
  onOk,
  hasKey,
  onCancel,
  isLoading,
}: Props) {
  const [optionSelected, setOptionSelected] =
    useState<UpdateIpiValueInInvoiceItemEnum>();

  const handlerOnCancel = () => {
    setOptionSelected(undefined);
    setIsGenerateDocument(false);
    onCancel();
  };

  return (
    <Modal
      title="Configuração de IPI para nota fiscal de devolução"
      open={open}
      onCancel={handlerOnCancel}
      okText="Confirmar"
      cancelText="Cancelar"
      confirmLoading={isLoading}
      onOk={() => onOk(optionSelected)}
    >
      <Form>
        <div style={{ marginBottom: 16 }}>
          <Typography.Text strong>
            Para os itens que possuem valor do IPI, selecione como o IPI deve
            ser tratado na nota fiscal:
          </Typography.Text>
        </div>

        <FloatingFormItem>
          <Select
            allowClear
            onChange={setOptionSelected}
            options={[
              {
                label: 'Não incluir IPI',
                value: UpdateIpiValueInInvoiceItemEnum.NONE_OPTIONS,
              },
              {
                label: 'Manter como valor do IPI',
                value: UpdateIpiValueInInvoiceItemEnum.IPI_NORMAL,
              },
              {
                label: ' Manter como valor do IPI devolvido',
                value: UpdateIpiValueInInvoiceItemEnum.IPI_RETURNED,
              },
            ]}
          />
        </FloatingFormItem>

        {hasKey && (
          <Form.Item
            name="checkList"
            initialValue={true}
            valuePropName="checked"
            style={{ marginTop: '16px' }}
          >
            <Checkbox
              onChange={({ target }) => {
                setIsGenerateDocument(target.checked);
              }}
            >
              Incluir documento referenciado na nota fiscal de devolução?
            </Checkbox>
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
}
